import { useEffect, useRef } from "react";
import { useGeneral } from "../contexts/GeneralContext";
import { useCart } from "../contexts/CartContext";
import { useNavigate } from "react-router-dom";
import {
  useChildDetails,
  useDisclaimer,
  useMealsSelection,
  useMealType,
} from "../contexts/SubscriptionContext";
import { useAuth } from "../contexts/AuthContext";

export default function PageWrapper({ children, className = "", loading }) {
  const { fetchExtraContent } = useGeneral();
  const calledRef = useRef(false);
  const logoutRef = useRef(false);

  const { setSelectedMealType } = useMealType();
  const { clearMeals } = useMealsSelection();
  const { clearChildDetails } = useChildDetails();
  const { resetDisclaimer } = useDisclaimer();
  const { fetchCart } = useCart();

  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleConfirmLogout = async () => {
    await signOut();
    localStorage.removeItem("cartId");
    localStorage.removeItem("mealCartId");
    localStorage.removeItem("unreadMessagesCount");
    setSelectedMealType(null);
    clearMeals();
    clearChildDetails();
    resetDisclaimer();
    await fetchCart();
    navigate("/");
  };

  useEffect(() => {
    const checkAuthFailure = async () => {
      const authFailed = localStorage.getItem("authFailed");
      if (authFailed === "1" && !logoutRef.current) {
        logoutRef.current = true; // run only once
        localStorage.removeItem("authFailed"); // reset
        await handleConfirmLogout();
        return; // skip fetchExtraContent
      }

      // Run fetchExtraContent only once
      if (loading === false && !calledRef.current) {
        calledRef.current = true;
        setTimeout(() => {
          fetchExtraContent();
        }, 300);
      }
    };

    checkAuthFailure();
  }, [
    loading,
    fetchExtraContent,
    handleConfirmLogout
  ]);

  return (
    <div
      className={`px-2 sm:px-2 md:px-12 lg:px-14 xl:px-[85px] pb-2 sm:pb-2 md:pb-4 lg:pb-4 xl:pb-4 mx-auto w-full  ${className}`}
    >
      {children}
    </div>
  );
}
